/**
 * SecretGameWidget — wrapper rond een geheime game-widget. De game vult de widget;
 * onderaan zit een "Verbergen"-knop die de widget op de TodayCard (Klok) zet. De
 * code opnieuw invoeren (SECRET_EVENT) tovert een verborgen game terug naar spel.
 */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { T, Icon } from './widgetTokens';
import TodayCard from './TodayCard';
import { SECRET_EVENT } from '../../../utils/secretUnlock';

export default function SecretGameWidget({ settings = {}, onSettingsChange, widget, children }) {
  const today = settings.mode === 'today';

  useEffect(() => {
    const onUnlock = () => { if (settings.mode === 'today') onSettingsChange?.({ mode: 'game' }); };
    window.addEventListener(SECRET_EVENT, onUnlock);
    return () => window.removeEventListener(SECRET_EVENT, onUnlock);
  }, [settings.mode, onSettingsChange]);

  if (today) return <TodayCard compact={widget?.h === 'compact'} />;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
      <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'center', pt: 1 }}>
        <Box
          onClick={() => onSettingsChange?.({ mode: 'today' })}
          sx={{
            display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'pointer',
            px: 1.25, py: 0.5, borderRadius: '0.5rem',
            color: T.outline, fontFamily: T.fontBody, fontWeight: 600, fontSize: '0.72rem',
            transition: 'all 0.15s', '&:hover': { color: T.primary, bgcolor: T.surfaceLow },
          }}
        >
          <Icon name="visibility_off" size={15} /> Verbergen
        </Box>
      </Box>
    </Box>
  );
}
